import apiSetting from '../apiSetting';
import { POST_API_PATH, GET_API_PATH } from "../../../constants"

// 取得通知列表
export const getNotifications = async (query = {}) => {
    const params = new URLSearchParams(query).toString();
    return await apiSetting({
        method: 'GET',
        url: `${GET_API_PATH.GET_URL_NOTIFICATIONS}?${params}`,
    });
};

// 取得未讀通知數量
export const getUnreadNotificationCount = async (query = {}) => {
    const params = new URLSearchParams(query).toString();
    return await apiSetting({
        method: 'GET',
        url: `${GET_API_PATH.GET_URL_NOTIFICATION_UNREAD_COUNT}?${params}`,
    });
};

// 根據角色取得通知
export const getNotificationsByRole = async (role) => {
    return await apiSetting({
        method: 'GET',
        url: `${GET_API_PATH.GET_URL_NOTIFICATIONS_BY_ROLE}/${role}`,
    });
};

// 標記單則通知為已讀
export const markNotificationAsRead = async (notificationId, data) => {
    return await apiSetting({
        method: 'POST',
        url: `${POST_API_PATH.POST_URL_NOTIFICATION_READ}/${notificationId}`,
        data,
    });
};

// 標記所有通知為已讀
export const markAllNotificationsAsRead = async (data) => {
    return await apiSetting({
        method: 'POST',
        url: POST_API_PATH.POST_URL_NOTIFICATION_READ_ALL,
        data,
    });
};
